import { render, staticRenderFns } from "./SmsModal.vue?vue&type=template&id=6c53a6fe&scoped=true&"
import script from "./SmsModal.vue?vue&type=script&lang=js&"
export * from "./SmsModal.vue?vue&type=script&lang=js&"
import style0 from "./SmsModal.vue?vue&type=style&index=0&id=6c53a6fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c53a6fe",
  null
  
)

export default component.exports